exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".data-and-bi-iframe {\n  height: 100%;\n  width: 100%;\n  border: 0;\n}\n", ""]);
